export enum GoalVsRegistrationType {
  Sale = 1,
  Registration = 2,
  Goal = 3,
  GoalSuggest = 4,
  Tendency = 5
}
